module.exports = __webpack_public_path__ + "img/67.59c4e912.png";